<!-- 卡片统计：el-row gutter 通过 el-col 左右 padding 实现列间距，勿对 .list 设 padding:0 -->
<template>
  <div class="statistics">
    <div class="statistics-grid" :style="statisticsGridStyle">
      <div v-for="(item, index) in list" :key="index" class="list">
        <el-card class="box-card" :style="cardStyle" shadow="never">
          <div class="title">
            <div class="title-text">
              <p class="label">{{ item.label }}</p>
              <p v-if="item.subtitle" class="subtitle">{{ item.subtitle }}</p>
            </div>
            <i v-if="item.icon" :class="`${item.icon}`" :style="{ color: item.iconColor }"></i>
            <matrix-tag v-if="item.tag" :color="item.tagColor" :text="item.tag"></matrix-tag>
          </div>
          <div class="value">
            <p><avue-count-up v-if="item.value" :end="item.value" :decimals="decimals(item.value)"></avue-count-up><span v-else>0</span></p>
            <p v-if="item.unit" :style="{ color: item.unitColor }">{{ item.unit }}</p>
          </div>
          <div :class="`subhead`">
            <p>{{ item.tip }}</p>
            <i v-if="item.compare == 1" :class="`el-icon-top`" :style="{ color: item.compareColor }"></i>
            <i v-if="item.compare == 0" :class="`el-icon-bottom`" :style="{ color: item.compareColor }"></i>
            <p :style="{ color: item.compareColor }">{{ item.subhead }}</p>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import matrixTag from '@/components/matrix/matrix-tag'

export default {
  name: 'matrix-statistics',
  components: {
    matrixTag
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    background: {
      type: String,
      default: ''
    },
    span: {
      type: String,
      default: '5'
    },
    /** 卡片水平间距（px），与页面 12px 栅格节奏一致；对应 el-row gutter */
    gutter: {
      type: Number,
      default: 12
    },
    height: {
      type: String,
      default: '120px'
    }
  },
  computed: {
    gutterNum () {
      const n = Number(this.gutter)
      return Number.isFinite(n) && n >= 0 ? n : 12
    },
    statisticsGridStyle () {
      const count = Array.isArray(this.list) && this.list.length ? this.list.length : 1
      return {
        gap: `${this.gutterNum}px`,
        gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
        gridAutoFlow: 'column'
      }
    },
    cardStyle () {
      const h = this.height || '120px'
      return {
        background: this.background || undefined,
        height: h,
        minHeight: h
      }
    },
    decimals () {
      return function (value) {
        if (value) {
          const list = `${value}`.split('.')
          return list.length === 1 ? 0 : list[1].length
        }
        return 0
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.statistics {
  width: 100%;
  min-width: 0;
  margin-bottom: 12px;
  box-sizing: border-box;
}

.statistics-grid {
  display: grid;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  align-items: stretch;
}

.statistics .list {
  display: flex;
  min-width: 0;
  width: 100%;
}

.statistics .list .box-card {
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;

  ::v-deep .el-card__body {
    height: 100%;
    box-sizing: border-box;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;

    .title-text {
      min-width: 0;
    }

    .label {
      min-width: 0;
      font-size: 14px;
      line-height: 20px;
      color: #6b7280;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subtitle {
      min-width: 0;
      margin-top: 2px;
      font-size: 12px;
      line-height: 18px;
      color: #86909c;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .value {
    display: flex;
    align-items: flex-end;
    margin: 12px 0;

    p {
      &:nth-child(1) {
        color: #1f2937;
        font-size: 24px;
        font-weight: bold;
      }

      &:nth-child(2) {
        color: #6b7280;
        font-size: 14px;
        margin-left: 8px;
      }
    }
  }

  .subhead {
    display: flex;
    align-items: center;
    min-width: 0;

    p {
      font-size: 14px;

      &:nth-child(1) {
        color: #6b7280;
        margin-right: 4px;
      }
    }
  }
}
</style>
